export default "/images/vendor/flag-icons/flags/4x3/ms.svg?bfac90ab8a9cbe5316ed9e9be000908e";